import request from '../utils/request.js'
export async function getBanner (type, callback) {
  return request.service({
    url: `/banners/${type}`,
    method: 'get',
  }).then(callback)
}

//解决方案和技术支持
export async function getComponents (params,callback) {
  return request.service({
    url:'/components',
    method: 'get',
    params:params
  }).then(callback)
}

